import { apiClient } from './apiClient';

export const userService = {
    getUsers: async () => {
        const response = await apiClient.get('/cedentes/masked');
        return response.data;
    },

    getUserByCpf: async (cpf) => {
        try {
            const response = await apiClient.get(`/cedentes/cpf/${encodeURIComponent(cpf)}`);
            return response.data;
        } catch (error) {
            if (error.response && error.response.status === 404) {
                throw new Error(
                    "CPF não encontrado. Caso seu CPF não esteja cadastrado, tente se autenticar usando seu número de matrícula: remova o hífen e preencha com zeros à esquerda até completar 11 dígitos. Exemplo: matrícula \"92345-3\" → \"00000923453\"."
                );
            }
            throw error;
        }
    },

    getUserById: async (id) => {
        const response = await apiClient.get(`/cedentes/${id}`);
        return response.data;
    },

    createCedente: async (payload) => {
        const response = await apiClient.post('/cedentes', payload);
        return response.data;
    },

    registerCedente: async (payload, isAdmin = false) => {
        const response = await apiClient.post('/cedentes/register', payload, {
            params: isAdmin ? { is_admin: true } : undefined,
        });
        return response.data;
    },

    getCedentes: async (search = "", limit = null, offset = null) => {
        const params = new URLSearchParams();
        if (search) params.append("search", search);
        if (limit !== null) params.append("limit", limit);
        if (offset !== null) params.append("offset", offset);

        const response = await apiClient.get(`/cedentes?${params.toString()}`);
        return response.data;
    },

    importCedentesCSV: async (processoId, file) => {
        const formData = new FormData();
        formData.append("file", file);
        const response = await apiClient.post(`/processos/${processoId}/cedentes/import`, formData);
        return response.data;
    },

    toggleCedenteActive: async (cedenteId) => {
        const response = await apiClient.patch(`/cedentes/${encodeURIComponent(cedenteId)}/toggle-active`);
        return response.data;
    }
};
